module.exports = __webpack_public_path__ + "img/Creative_Scotland_bw.bed79fd2.png";